module.exports = __webpack_public_path__ + "static/media/garden_backyard.1723cf36.svg";